import { Button } from "@/shared/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/core/context/AuthContext";
import { ROUTES } from "@/core/router/routes";

export default function BrokenLinkContent() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const handleButtonClick = () => {
    if (isAuthenticated) {
      navigate(`/${ROUTES.Dashboard.Root}`);
    } else {
      navigate(`/${ROUTES.Auth.Root}/${ROUTES.Auth.SignIn}`);
    }
  };

  const buttonText = isAuthenticated ? "Dashboard'a Git" : "Giriş Yap";

  return (
    <div className="auth-page-container flex items-center flex-col w-[395px]">
      <h3 className="text-[24px] leading-[32px] tracking-[-0.015em] font-[700] text-[#09090B] mb-[12px] text-center">
        Geçersiz davet bağlantısı
      </h3>
      <div className="text-[16px] font-400 leading-[24px] mb-[24px] text-center text-muted-foreground">
        Bu davet bağlantısı geçersiz veya eksik bilgiler içeriyor. Lütfen davet linkini kontrol edin.
      </div>
      <div className="w-full flex flex-col items-center justify-center">
        <Button variant="success" onClick={handleButtonClick}>
          {buttonText}
        </Button>
      </div>
    </div>
  );
}

